/*
 *
 * WAA Assessment Settings constants
 *
 */

export const GET_WORK_FACTORS = "app/AssessmentSettingsWAA/GET_WORK_FACTORS";
export const GET_WORK_FACTORS_SUCCESS =
  "app/AssessmentSettingsWAA/GET_WORK_FACTORS_SUCCESS";
export const GET_WORK_FACTORS_ERROR =
  "app/AssessmentSettingsWAA/GET_WORK_FACTORS_ERROR";

export const CREATE_WORK_FACTOR =
  "app/AssessmentSettingsWAA/CREATE_WORK_FACTOR";
export const CREATE_WORK_FACTOR_SUCCESS =
  "app/AssessmentSettingsWAA/CREATE_WORK_FACTOR_SUCCESS";
export const CREATE_WORK_FACTOR_ERROR =
  "app/AssessmentSettingsWAA/CREATE_WORK_FACTOR_ERROR";

export const EDIT_WORK_FACTOR = "app/AssessmentSettingsWAA/EDIT_WORK_FACTOR";
export const EDIT_WORK_FACTOR_SUCCESS =
  "app/AssessmentSettingsWAA/EDIT_WORK_FACTOR_SUCCESS";
export const EDIT_WORK_FACTOR_ERROR =
  "app/AssessmentSettingsWAA/EDIT_WORK_FACTOR_ERROR";

export const COPY_WORK_FACTOR = "app/AssessmentSettingsWAA/COPY_WORK_FACTOR";
export const COPY_WORK_FACTOR_SUCCESS =
  "app/AssessmentSettingsWAA/COPY_WORK_FACTOR_SUCCESS";
export const COPY_WORK_FACTOR_ERROR =
  "app/AssessmentSettingsWAA/COPY_WORK_FACTOR_ERROR";

export const RESEND_INVITATION = "app/AssessmentSettingsWAA/RESEND_INVITATION";
export const RESEND_INVITATION_SUCCESS =
  "app/AssessmentSettingsWAA/RESEND_INVITATION_SUCCESS";
export const RESEND_INVITATION_ERROR =
  "app/AssessmentSettingsWAA/RESEND_INVITATION_ERROR";

export const DELETE_INVITATION = "app/AssessmentSettingsWAA/DELETE_INVITATION";
export const DELETE_INVITATION_SUCCESS =
  "app/AssessmentSettingsWAA/DELETE_INVITATION_SUCCESS";
export const DELETE_INVITATION_ERROR =
  "app/AssessmentSettingsWAA/DELETE_INVITATION_ERROR";

export const RESET_DELETE_CONFIRMATION =
  "app/AssessmentSettingsWAA/RESET_DELETE_CONFIRMATION";

export const UPDATE_WORK_FACTOR_STATUS =
  "app/AssessmentSettingsWAA/UPDATE_WORK_FACTOR_STATUS";
export const UPDATE_WORK_FACTOR_STATUS_SUCCESS =
  "app/AssessmentSettingsWAA/UPDATE_WORK_FACTOR_STATUS_SUCCESS";
export const UPDATE_WORK_FACTOR_STATUS_ERROR =
  "app/AssessmentSettingsWAA/UPDATE_WORK_FACTOR_STATUS_ERROR";

export const workFactorsList = {
  4: "Make use of their abilities",
  5: "Do work that can give them a feeling of accomplishment",
  11: "Are provided with enough work to be busy all the time",
  14: "Are provided with opportunities for advancement",
  13: "Are able to give directions to others",
  3: "Are able to plan their work with little supervision",
  9: "Are paid at a rate that compares well with other workers",
  16: "Get along well with each other",
  2: "Are able to try out their own ideas",
  1: "Are able to work alone",
  15: "Are never pressured to do things that go against their sense of right and wrong",
  20: "Are treated fairly",
  12: "Receive recognition for the work they do",
  6: "Are able to make decisions on their own",
  8: "Are provided with steady employment",
  17: "Are able to do things for other people",
  18: "Have supervisors who back them up in discussions with management",
  19: "Have supervisors who are good at training",
  10: "Are able to do something different every day",
  7: "Have good working conditions",
};

export const workFactorIdToAbbrev = {
  1: "IND_rank",
  2: "CRE_rank",
  3: "ATO_rank",
  4: "AU_rank",
  5: "ACH_rank",
  6: "RES_rank",
  7: "WC_rank",
  8: "SEC_rank",
  9: "CMP_rank",
  10: "VAR_rank",
  11: "ACT_rank",
  12: "REC_rank",
  13: "AUT_rank",
  14: "ADV_rank",
  15: "MV_rank",
  16: "CW_rank",
  17: "SS_rank",
  18: "SR_rank",
  19: "ST_rank",
  20: "PP_rank",
};

export const workFactorAbbrevToId = {
  AU_rank: 4,
  ACH_rank: 5,
  ACT_rank: 11,
  ADV_rank: 14,
  AUT_rank: 13,
  ATO_rank: 3,
  CMP_rank: 9,
  CW_rank: 16,
  CRE_rank: 2,
  IND_rank: 1,
  MV_rank: 15,
  PP_rank: 20,
  REC_rank: 12,
  RES_rank: 6,
  SEC_rank: 8,
  SS_rank: 17,
  SR_rank: 18,
  ST_rank: 19,
  VAR_rank: 10,
  WC_rank: 7,
};

export const levels = {
  1: {
    levelName: "Least important",
    levelCircleColor: "#d50057",
  },
  2: {
    levelName: "Little importance",
    levelCircleColor: "#ffa300",
  },
  3: {
    levelName: "Somewhat important",
    levelCircleColor: "#425cc7",
  },
  4: {
    levelName: "Very important",
    levelCircleColor: "#2dccd3",
  },
  5: {
    levelName: "Most important",
    levelCircleColor: "#00c067",
  },
};

export const checkEmailValid = (emailAddress) => {
  const emailSplit = emailAddress.split("@");
  return (
    typeof emailSplit[0] === "string" &&
    emailSplit[0].length > 0 &&
    typeof emailSplit[1] === "string" &&
    emailSplit[1].length > 0
  );
};
